import React from 'react'
import './navbar.css'


function handleLogout() {
    var data = { type: "mrkrlogout"};
    window.postMessage(data, "*");
    const logoutUrl = `${process.env.REACT_APP_COGNITO_DOMAIN}/logout?response_type=token&client_id=${process.env.REACT_APP_CLIENT_ID}&logout_uri=${encodeURIComponent(process.env.REACT_APP_CALLBACK_TO_LOGOUT)}`;
    window.location.href = logoutUrl;
}


export function handleLogin(){
    window.location.href = `${process.env.REACT_APP_COGNITO_DOMAIN}/oauth2/authorize?client_id=${process.env.REACT_APP_CLIENT_ID}&response_type=token&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=${process.env.REACT_APP_CALLBACK_TO_LOGIN}`
}


function Navbar(props) {

    return (
    <div className='mrkrnavbar'>
        <a href='https://mark-r.com'>
            <img 
            src="mark_r_logo_TM.png"
            alt="Extension Logo"
            className='logoImage'
            />
        </a>
        
        <div style={{display: 'flex', alignItems: 'center'}}>
        {props.login && 
            <button
                id="logoutButton"
                className="btn btn-link logoutButton"
                data-toggle="tooltip"
                title="Logout"
                onClick={handleLogout}
            >
            <img
            src="logout-svgrepo-com.svg"
            alt="Logout"
            className='logoutIcon'
            />
            </button>  
        }
        {props.logout &&
            <button
                id="loginButton"
                className="btn btn-link logoutButton"
                data-toggle="tooltip"
                title="Login"
                onClick={handleLogin}
                >
                <img
                src="login-svgrepo-com.svg"
                alt="Login"
                className='logoutIcon'
                />
            </button>
        }
        </div>
    </div>
  )
}

export default Navbar